import cx from 'classnames';
import React from 'react';
import type { ReactElement } from 'react';
import styled from 'styled-components';
import { Panel as Panel_ } from '../panel';

const Container = styled(Panel_)`
  width: 90%;
  max-width: 90%;
  height: auto;
  margin-top: 24px;
  margin-left: 119px;

  .panel-title {
    text-align: left;
    font-weight: 600;
    font-size: 1.75rem !important;
    margin-left: 50px;
  }
`;



export const Panel = ({ className, children, title, ...rest }: Panel.Props): ReactElement => (
  <Container className={cx('mr-auto', className)} {...rest}>
    {title && <h1 className='panel-title'>{title}</h1>}
    {children}
  </Container>
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace Panel {
  export type Props = React.PropsWithChildren<{
    className?: string;
    title?: string;
  }>;
}
